import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../../utils/api";
import { LoginHelper } from "../../../utils/LoginHelper";
import AdminListCoverThumb from "../AdminListCoverThumb";

export default function WorkshopAdminListRow({ workshop, onRemoved, onError }) {
	const [isRemoving, setIsRemoving] = useState(false);

	function handleRemove() {
		if (isRemoving) return;
		if (!window.confirm(`کارگاه «${workshop.title}» حذف شود؟`)) return;
		setIsRemoving(true);
		onError("");
		api
			.workshopRemove({
				token: LoginHelper.getToken(),
				workshop_id: workshop.id,
			})
			.then(() => onRemoved())
			.catch((err) => {
				if (err?.data?.message) {
					onError(err.data.message);
				}
			})
			.finally(() => setIsRemoving(false));
	}

	const episodeCount = Number(workshop.episodes?.length || 0);
	const priceLabel = workshop.price
		? `${Number(workshop.price).toLocaleString("fa-IR")} تومان`
		: "رایگان";

	return (
		<article className="flex flex-col gap-3 rounded-[12px] border border-darkBlue/10 bg-white p-4 transition hover:border-darkBlue/20 sm:flex-row sm:items-center sm:justify-between">
			<div className="min-w-0 flex-1 text-right">
				<div className="flex flex-wrap items-start gap-3">
					<AdminListCoverThumb
						src={workshop.image_url}
						alt={workshop.title}
						showWhenEmpty
					/>
					<div className="min-w-0 flex-1">
						<h3 className="font-Vazir-700 text-[15px] text-darkBlue">
							{workshop.title}
						</h3>
						{workshop.profile_detail?.name && (
							<p className="mt-1 font-Vazir-400 text-[12px] text-darkBlue/55 line-clamp-1">
								درمانگر: {workshop.profile_detail.name}
							</p>
						)}
					</div>
				</div>
				<div className="mt-2 flex flex-wrap gap-2">
					{workshop.fa_confirm_state && (
						<span className="rounded-[8px] bg-lightCta px-2.5 py-1 font-Vazir-600 text-[12px] text-darkBlue">
							{workshop.fa_confirm_state}
						</span>
					)}
					<span className="rounded-[8px] bg-darkBlue/5 px-2.5 py-1 font-Vazir-500 text-[12px] text-darkBlue/70">
						{episodeCount.toLocaleString("fa-IR")} جلسه
					</span>
					{workshop.video_duration ? (
						<span className="rounded-[8px] bg-darkBlue/5 px-2.5 py-1 font-Vazir-500 text-[12px] text-darkBlue/70">
							{Number(workshop.video_duration).toLocaleString("fa-IR")}{" "}
							دقیقه
						</span>
					) : null}
					<span className="rounded-[8px] bg-darkBlue/5 px-2.5 py-1 font-Vazir-500 text-[12px] text-darkBlue/70">
						{priceLabel}
					</span>
					<span className="rounded-[8px] bg-darkBlue/5 px-2.5 py-1 font-Vazir-500 text-[12px] text-darkBlue/70">
						{Number(workshop.enrolls_count || 0).toLocaleString("fa-IR")}{" "}
						ثبت‌نام
					</span>
				</div>
			</div>
			<div className="flex shrink-0 flex-wrap gap-2 sm:justify-end">
				<Link
					to={`/episode_add/${workshop.id}/`}
					className="rounded-[10px] border border-cta/30 bg-cta/5 px-3 py-2 text-center font-Vazir-600 text-[13px] text-cta no-underline transition hover:bg-cta/10"
				>
					+ افزودن جلسه
				</Link>
				<Link
					to={`/workshop_detail/${workshop.id}/`}
					target="_blank"
					rel="noopener noreferrer"
					className="rounded-[10px] border border-darkBlue/15 px-3 py-2 font-Vazir-600 text-[13px] text-darkBlue no-underline transition hover:border-darkBlue/30"
				>
					مشاهده
				</Link>
				<Link
					to={`/workshop_edit/${workshop.id}/`}
					className="rounded-[10px] bg-lightCta px-4 py-2 font-Vazir-600 text-[13px] text-darkBlue no-underline transition hover:bg-[#E0EEF8]"
				>
					ویرایش
				</Link>
				<button
					type="button"
					disabled={isRemoving}
					onClick={handleRemove}
					className="rounded-[10px] border border-red-200 px-4 py-2 font-Vazir-600 text-[13px] text-red-600 transition hover:bg-red-50 disabled:opacity-60"
				>
					{isRemoving ? "…" : "حذف"}
				</button>
			</div>
		</article>
	);
}
